export const anatomy = [`container`, `controls`, `control`, `control-group`] as const;
export const nodeAnatomy = [`container`, `body`, `heading`, `tagline`, `children`, `footer`] as const;

export type GraphPart = (typeof anatomy)[number];
export type NodePart = (typeof nodeAnatomy)[number];
